import { useEffect } from 'react';

export const mrMap = {
  DE: 'Herr',
  EN_US: 'Mr',
  ES: 'Señor',
  FR: 'M.',
  IT: 'Sig.',
  JA: 'Mr',
  KO: 'Mr',
  PL: 'Pan',
  PT: 'Sr.',
  RU: 'Мистер',
  ZH_HANT: '先生',
  ZH_HANS: '先生',
};

export const mrsMap = {
  DE: 'Frau',
  EN_US: 'Mrs',
  ES: 'Sra.',
  FR: 'Mme',
  IT: 'Sig.ra',
  JA: 'Mrs',
  KO: 'Mrs',
  PL: 'Pani',
  PT: 'Sra.',
  RU: 'Миссис',
  ZH_HANT: '太太',
  ZH_HANS: '太太',
};

export const msMap = {
  DE: 'Fräulein',
  EN_US: 'Ms',
  ES: 'Srta.',
  FR: 'Mlle',
  IT: 'Sig.na',
  JA: 'Ms',
  KO: 'Ms',
  PL: 'Panna',
  PT: 'Sra.',
  RU: 'Мисс',
  ZH_HANT: '女士',
  ZH_HANS: '女士',
};

interface UseTitleUpdateProps {
  defaultValues: { title: string };
  languageCode: string;
}

export const useTitleUpdate = ({
  defaultValues,
  languageCode,
}: UseTitleUpdateProps) => {
  useEffect(() => {
    const updateTitle = () => {
      if (Object.values(mrMap)?.includes(defaultValues.title)) {
        defaultValues.title = mrMap[languageCode as keyof typeof mrMap];
      } else if (Object.values(mrsMap)?.includes(defaultValues.title)) {
        defaultValues.title = mrsMap[languageCode as keyof typeof mrsMap];
      } else if (Object.values(msMap)?.includes(defaultValues.title)) {
        defaultValues.title = msMap[languageCode as keyof typeof msMap];
      } else {
        defaultValues.title = mrMap[languageCode as keyof typeof mrMap];
      }
    };

    updateTitle();
  }, [defaultValues, languageCode]);
};
